import { BASE_IMAGES } from "../../mediaSources"

export const HEADER_MEDIA_SOURCES = {
    header: {
        logo: {
            img: {
                defaultSrc: `${BASE_IMAGES}/Header/guacnTacos-768.webp`,
                width: 768,
                height: 455,
                alt: "GuacnTacos Logo"
            },
            srcSet: [
                { media: "(min-width: 1920px)", width: 768, height: 455, src: `${BASE_IMAGES}/Header/guacnTacos-768.webp`, type: "image/webp" },
                { media: "(min-width: 1600px)", width: 640, height: 379, src: `${BASE_IMAGES}/Header/guacnTacos-640.webp`, type: "image/webp" },
                { media: "(min-width: 768px)", width: 480, height: 284, src: `${BASE_IMAGES}/Header/guacnTacos-480.webp`, type: "image/webp" },
                { media: "(min-width: 340px)", width: 340, height: 201, src: `${BASE_IMAGES}/Header/guacnTacos-340.webp`, type: "image/webp" },
                { media: "(min-width: 0px)", width: 240, height: 136, src: `${BASE_IMAGES}/Header/guacnTacos-240.webp`, type: "image/webp" }
            ]
        }
    }
}